import React, { useState, useEffect, useRef } from "react";
import { Fieldset } from "primereact/fieldset";
import RBBLiframe from "../../Component/ReviewPage/iframe/RBBLiframe";
import { Button } from "primereact/button";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import { setUserSessionAuthKey } from "../../Component/commonUtils";
import axios from "axios";
import "./externalIframe.css";

export default function ExternalIframe(props) {
  const [authKey, setAuthKey] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("authKey");
  });

  const [reportGuid, setReportGuid] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("reportGuid");
  });

  console.log("Auth key received:", authKey);

  const submitToBolagserket = () => {
    let axiosConfig = {
      headers: {
        "User-Session-Auth-Key": authKey,
        language: "sw"
      }
    };
    let bolagsverketSubmitObj = {
      reportGuid: reportGuid,
      limitSubmitCount: false
    };

    axios
      .post("/xhtml/submitToBolagsverket", bolagsverketSubmitObj, axiosConfig)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <div className="externalIframe-pdf-div">
        {" "}
        <RBBLiframe
          className="externalIframe"
          height="900px"
          width="100%"
          authKey={authKey}
          reportGuid={reportGuid}
        />{" "}
      </div>

      <br />
      <div>
        <center>
          <Button
            label={TranslationFile.uploadToBlogsText["sw"]}
            icon="pi pi-send"
            onClick={() => submitToBolagserket()}
          />
        </center>
      </div>
    </div>
  );
}
